export const merchantArray = [
  {
    img: 'https://iccdn.in/merchant/logos/amazon-logo.svg',
    name: 'Amazon',
  },
  {
    img: 'https://iccdn.in/merchant/logos/flipkart-logo.svg',
    name: 'Flipkart',
  },
  {
    img: 'https://iccdn.in/merchant/logos/tata-cliq-logo.svg',
    name: 'TATA Cliq',
  },
  {
    img: 'https://iccdn.in/merchant/logos/vijaysales-logo.png',
    name: 'Vijay Sales',
  },

  {
    img: 'https://iccdn.in/merchant/logos/sangeetha-logo.jpg',
    name: 'Sangeetha Mobiles',
  },

  {
    img: 'https://iccdn.in/merchant/logos/myntra-logo.svg',
    name: 'Myntra',
  },
  {
    img: 'https://iccdn.in/merchant/logos/decathlon-logo.svg',
    name: 'Decathlon',
  },
  {
    img: 'https://iccdn.in/merchant/logos/cult-fit-logo.jpg',
    name: 'Cult fit',
  },
  {
    img: 'https://iccdn.in/merchant/logos/mmt-logo.svg',
    name: 'Make My Trip',
  },
  {
    img: 'https://iccdn.in/merchant/logos/via-logo.png',
    name: 'Via',
  },

  {
    img: 'https://iccdn.in/merchant/logos/sasti-ticket-logo.png',
    name: 'Sasti Ticket',
  },
  {
    img: 'https://iccdn.in/merchant/logos/happyeasygo-logo.png',
    name: 'Happy Easy Go',
  },
  {
    img: 'https://iccdn.in/merchant/logos/pepperfry-logo.svg',
    name: 'Pepperfry',
  },
  {
    img: 'https://iccdn.in/merchant/logos/royaloak-logo.png',
    name: 'Royal Oak',
  },

  {
    img: 'https://iccdn.in/merchant/logos/ikea-logo.svg',
    name: 'Ikea',
  },
  {
    img: 'https://iccdn.in/merchant/logos/urban-ladder-logo.svg',
    name: 'Urban Ladder',
  },
  {
    img: 'https://iccdn.in/merchant/logos/noise-logo.png',
    name: 'Gonoise',
  },
  {
    img: 'https://iccdn.in/merchant/logos/asics-logo.svg',
    name: 'Asics',
  },
  {
    img: 'https://iccdn.in/merchant/logos/titan-logo.svg',
    name: 'Titan',
  },
  {
    img: 'https://iccdn.in/merchant/logos/fossil-logo.svg',
    name: 'Fossil',
  },
];

export const iciciEducationMerchants = [
  {
    img: 'https://iccdn.in/campaigns/icici-educational/coursera.png',
    name: 'coursera',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/jigsaw.png',
    name: 'jigsaw',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/classplus.png',
    name: 'classplus',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/unacademy.png',
    name: 'unacademy',
  },

  {
    img: 'https://iccdn.in/campaigns/icici-educational/coding-ninjas.png',
    name: 'coding ninjas',
  },

  {
    img: 'https://iccdn.in/campaigns/icici-educational/cuemath.png',
    name: 'cuemath',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/intellipaat.png',
    name: 'intellipaat',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/pesto.png',
    name: 'pesto',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/meritnation.png',
    name: 'meritnation',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/testbook.png',
    name: 'testbook',
  },

  {
    img: 'https://iccdn.in/campaigns/icici-educational/vedantu.png',
    name: 'vedantu',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/collegedunia.png',
    name: 'collegedunia',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/ask-iitians.png',
    name: 'ask-iitians',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/lido.png',
    name: 'lido',
  },

  {
    img: 'https://iccdn.in/campaigns/icici-educational/physics-wallah.png',
    name: 'physics wallah',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/filo.png',
    name: 'filo',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/adda247.png',
    name: 'adda 24/7',
  },
];



// WEBPACK FOOTER //
// ./routes/campaign-fast-feature/constants/index.js